module.exports = __webpack_public_path__ + "img/nodeBackgroundGradientWhite.7211e417.svg";